import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Alert, Button, ButtonToolbar, Collapse } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import validate from './Validate';
import SmartCard from '../../../shared/components/SmartCard';
import renderField from '../../../shared/components/form/RenderField';
import { onShowAlert } from '../../../shared/utils/smartutils';
import colorPicked from './ColorPicked';
import select from '../../../shared/components/form/Select';
import GraphQl from '../../../GraphQL';
import { VISIBILITY } from '../../../shared/utils/constants';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../../redux/actions/loadingActions';
import { calendarNotificationListByCalendarId } from '../../../shared/queries/Calendar';
import DialogForFullScreenComponent from './DialogForFullScreenComponent';
import AlertNotifications from './AlertNotifications';

const CalendarForm = (props) => {
  const {
    t,
    dispatch,
    change,
    initialize,
    dto,
    handleSubmit,
    removeItemClickHandler,
  } = props;

  const visibility = [
    { value: VISIBILITY.INTERNAL, label: t('calendar.visibility.I') },
    { value: VISIBILITY.EXTERNAL, label: t('calendar.visibility.E') },
  ];
  const [calendarNotifications, setCalendarNotifications] = useState([]);
  const [notificationAlert, setNotificationAlert] = useState({});
  const [toggleDialog, setToggleDialog] = useState(false);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const loadNotificationListByCalendarId = (id) => {
    const filter = { id };
    const query = calendarNotificationListByCalendarId(filter);
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        setCalendarNotifications(res.calendarNotificationListByCalendarId);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        onShowAlert(
          'danger',
          'errors.title',
          'errors.error-to-loading',
          setNotificationAlert
        );
      });
  };

  const onChangeAlertNotificationList = (value) => {
    change('calendarNotifications', value);
  };

  const onColorChange = (value) => {
    change('colorHexa', value);
  };

  const toggleDialogScreen = () => {
    setToggleDialog(!toggleDialog);
  };

  useEffect(() => {
    initialize(dto);
    if (dto.id > 0) {
      loadNotificationListByCalendarId(dto.id);
    }
  }, [dto]);

  return (
    <MuiThemeProvider>
      <>
        <DialogForFullScreenComponent
          toggleDialog={toggleDialogScreen}
          isOpen={toggleDialog}
          color="warning"
          title="notifications.attention"
          message="notifications.delete_calendar"
          btns={[
            {
              order: 1,
              onClick: toggleDialogScreen,
              message: 'general.cancel',
              color: 'danger',
            },
            {
              order: 2,
              color: 'primary',
              onClick: () => {
                toggleDialogScreen();
                removeItemClickHandler(dto.id);
              },
              message: 'general.confirm',
            },
          ]}
        />
        <SmartCard>
          <Collapse
            isOpen={
              notificationAlert.status && notificationAlert.color === 'danger'
            }
            className="width100"
          >
            <Alert color={notificationAlert.color}>
              {t(notificationAlert.message)}
            </Alert>
          </Collapse>
          <form className="form" onSubmit={handleSubmit}>
            <div className="form__form-group">
              <span className="form__form-group-label modal-span-flex">
                {t('general.name')}
              </span>
              <div className="form_form-group-field">
                <Field
                  name="name"
                  type="text"
                  component={renderField}
                  maxLength="50"
                  placeholder={t('general.placeholders.type-here')}
                />
              </div>
            </div>
            <div className="form__form-group--2_columns d-flex nowrap">
              <div className="form_form-group-field modal-field pr-3">
                <Field
                  name="colorHexa"
                  component={colorPicked}
                  colorSelected={dto.colorHexa}
                  onHandleChange={onColorChange}
                />
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label modal-span-flex">
                  {t('calendar.visibility.title')}
                </span>
                <div className="form_form-group-field">
                  <Field
                    name="visibility"
                    type="text"
                    component={select}
                    options={visibility}
                    placeholder={t('calendar.placeholders.select')}
                  />
                </div>
              </div>
            </div>
            <AlertNotifications
              data={calendarNotifications}
              onChangeAlertNotificationList={onChangeAlertNotificationList}
            />
          </form>
          <ButtonToolbar className="form__button-toolbar">
            {dto.id && (
              <Button color="danger" onClick={toggleDialogScreen}>
                {t('general.delete')}
              </Button>
            )}
            <Button color="success" onClick={(values) => handleSubmit(values)}>
              {t('general.save')}
            </Button>
          </ButtonToolbar>
        </SmartCard>
      </>
    </MuiThemeProvider>
  );
};

CalendarForm.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  removeItemClickHandler: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  reduxForm({
    form: 'CalendarScreenForm',
    validate,
  })(CalendarForm)
);
